import script from "./nav.vue?vue&type=script&setup=true&lang=ts"
export * from "./nav.vue?vue&type=script&setup=true&lang=ts"

import "./nav.vue?vue&type=style&index=0&id=19a51cb5&lang=less&scoped=true"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19a51cb5"]])

export default __exports__